import { FC } from 'react';

import { Tabs, Tab } from '@mui/material';

import { ReferralRewardTabsEnum } from '../constants';

import { ReferralRewardSettingsPageTabsProps } from './types';

import styles from './ReferralRewardSettingsPageTabs.module.css';

const { tabsContainer } = styles;

export const ReferralRewardSettingsPageTabs: FC<ReferralRewardSettingsPageTabsProps> = ({ currentTab, setTab }) => {
  const tabs = Object.values(ReferralRewardTabsEnum);

  return (
    <Tabs className={tabsContainer} textColor="inherit" value={currentTab} variant="scrollable" scrollButtons="auto">
      {tabs.map((tab: ReferralRewardTabsEnum) => {
        const onClick = () => setTab(tab);

        return <Tab onClick={onClick} label={tab} value={tab} key={tab} />;
      })}
    </Tabs>
  );
};
